import React from 'react';
import { X } from 'lucide-react';

const LegalModal = ({ isOpen, onClose, title, content }) => {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
      onClick={handleBackdropClick}
      data-testid="legal-modal-backdrop"
    >
      <div 
        className="relative w-full max-w-3xl max-h-[85vh] bg-gradient-to-br from-[#1F1914] to-[#0D0B09] rounded-2xl border border-[#C9A97B]/20 shadow-2xl overflow-hidden"
        data-testid="legal-modal-container"
      >
        {/* Header */}
        <div className="sticky top-0 z-10 flex items-center justify-between px-6 py-4 bg-[#1A1512]/95 backdrop-blur-sm border-b border-[#C9A97B]/10">
          <h2 className="text-xl md:text-2xl font-display font-bold text-[#F5F0E8]">
            {title}
          </h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-full bg-[#C9A97B]/10 flex items-center justify-center text-[#C9A97B] hover:bg-[#C9A97B]/20 transition-colors"
            data-testid="legal-modal-close-btn"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Content */}
        <div className="px-6 py-6 overflow-y-auto max-h-[calc(85vh-80px)] custom-scrollbar">
          <div className="prose prose-invert max-w-none">
            {content.split('\n').map((paragraph, index) => {
              // Check if it's a heading (starts with number and dot or all caps)
              const isHeading = /^\d+\.\s/.test(paragraph.trim());
              const isSubHeading = /^\d+\.\d+\./.test(paragraph.trim());
              const isBulletPoint = paragraph.trim().startsWith('•');
              
              if (!paragraph.trim()) {
                return <div key={index} className="h-4" />;
              }
              
              if (isHeading && !isSubHeading) {
                return (
                  <h3 key={index} className="text-lg font-display font-semibold text-[#C9A97B] mt-6 mb-3">
                    {paragraph}
                  </h3>
                );
              }
              
              if (isSubHeading) {
                return (
                  <p key={index} className="text-[#F5F0E8] font-medium mt-3 mb-2">
                    {paragraph}
                  </p>
                );
              }
              
              if (isBulletPoint) {
                return (
                  <p key={index} className="text-[#BFB5A5] leading-relaxed pl-2 py-0.5">
                    {paragraph}
                  </p>
                );
              }
              
              return (
                <p key={index} className="text-[#BFB5A5] leading-relaxed mb-3">
                  {paragraph}
                </p>
              );
            })}
          </div>
        </div>

        {/* Footer */}
        <div className="sticky bottom-0 px-6 py-4 bg-[#1A1512]/95 backdrop-blur-sm border-t border-[#C9A97B]/10">
          <button
            onClick={onClose}
            className="w-full py-3 rounded-xl bg-[#C9A97B]/10 text-[#C9A97B] font-medium hover:bg-[#C9A97B]/20 transition-colors"
            data-testid="legal-modal-accept-btn"
          >
            Anladım
          </button>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
